module.exports = __webpack_public_path__ + "static/media/bg-register.7d936ade.webp";